import { render, staticRenderFns } from "./TransporterDetail.vue?vue&type=template&id=4a5556fa&scoped=true&"
import script from "./TransporterDetail.vue?vue&type=script&lang=js&"
export * from "./TransporterDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransporterDetail.vue?vue&type=style&index=0&id=4a5556fa&scoped=true&lang=css&"
import style1 from "./TransporterDetail.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5556fa",
  null
  
)

export default component.exports